import type { SeasonalThemeName } from './SeasonalTheme';

/**
 * THE ONE SWITCH
 * --------------
 * Pick which theme the admin uses. Change the value, deploy, done.
 * 'original' = the app exactly as it is without any seasonal decoration.
 *
 * Available themes are registered in `src/seasonal/themes/index.ts`.
 */
export const ACTIVE_SEASONAL_THEME: SeasonalThemeName = 'original';
